import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import TpClientInvoiceService from '../../../Services/TpClientInvoiceService';
import FinalizeTpClientInvoiceBulkItem from '../../../Domain/FinalizeTpClientInvoiceBulkItem';

export default class FinalizeTpClientInvoiceBulkWindowDescription extends React.Component {
  static titleForEdit = 'Invoice Bulk Finalization';
  static finishButtonLabel = 'Finalize';
  static itemType = FinalizeTpClientInvoiceBulkItem;
  static serviceFunction = (editedItem) =>
    TpClientInvoiceService.FinalizeSelectedInvoice(
      editedItem,
      FinalizeTpClientInvoiceBulkWindowDescription.getSearchParameters(),
      FinalizeTpClientInvoiceBulkWindowDescription.getSelected(),
      FinalizeTpClientInvoiceBulkWindowDescription.getAllItemsInTheSearchSetAreSelected()
    );

  static getSelected() {
    return null;
  }

  static getSearchParameters() {
    return null;
  }

  static getAllItemsInTheSearchSetAreSelected() {
    return null;
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'IdListString',
          label: 'Invoice IDs (id1,id2,id3...)',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
      ],
    },
  ];
}
